module.exports = __webpack_public_path__ + "img/microphone.d5d0cb55.png";